import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { ActivitiesView } from './activities.view';
import { CreateActivityView } from './create/createActivity.view';
import { UpdateActivityView } from './create/updateActivity.view';

/**
 * Routeur pour la gestion des activités
 * 
 * Ce routeur gère la navigation entre :
 * - Liste des activités (/activities)
 * - Création d'activité (/activities/create)
 * - Modification d'activité (/activities/:id)
 * 
 * @returns Composant React du routeur des activités
 */
export const ActivityRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <ActivitiesView />
        </Route>
        <Route path={`${path}/create`}>
          <CreateActivityView />
        </Route>
        <Route path={`${path}/:id`}>
          <UpdateActivityView />
        </Route>
      </Switch>
    </div>
  );
};
